<br>
  <div class="p-grid">
    <div class="p-col-12">
      <h4>Zip Codes</h4>
    </div>
  </div>
  <br>
    <form id="zipCodeForm" #zipCodeForm="ngForm">
      <div class="p-grid">
        <div class="p-col-4">
          <h6>Zip Code</h6>
          <input pInputText fluid #zipCodeInput name="code" [(ngModel)]="zipCode.code" required/>
        </div>
        <div class="p-col-4">
          <h6>City</h6>
          <input pInputText fluid name="city" [(ngModel)]="zipCode.city" required />
        </div>
        <div class="p-col-4">
          <h6>Tax Rate</h6>
          <input pInputText fluid name="taxRate" [(ngModel)]="zipCode.taxRate" />
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 columnPadding">
          @if (zipCodeForm.invalid && zipCodeForm.submitted) {
            <div class="alert alert-danger" role="alert">
              There are errors on this page. Please correct the errors and resubmit.
            </div>
          }
        </div>
        <div class="p-col-12" style="text-align: right">
          <p-button
            type="submit"
            (click)="saveZipCode(zipCodeForm)"
            severity="success"  
            [disabled]="saving"
            label="Save">
          </p-button>
          <p-button
            type="button"
            severity="warn"  
            (click)="clear(zipCodeForm);"
            label="Clear">
          </p-button>
        </div>
      </div>
    </form>
    <br>
      <br>
        <p-table showGridlines stripedRows responsiveLayout="stack" [columns]="cols" [value]="zipCodes" [paginator]="true" [rows]="30" #zipTable>
          <ng-template pTemplate="caption">
            <div style="text-align: right">
              <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
              <input type="text" pInputText fluid size="50" placeholder="Search..." (input)="zipTable.filterGlobal($event.target.value, 'contains')" style="width:auto">
            </div>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for (col of columns; track col) {
                <th [pSortableColumn]="col.field" [style.width]="col.width">
                  {{col.header}}
                  @if (col.header != '') {
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  }
                </th>
              }
              <th [style.width]="'10%'"><!-- for the buttons --></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-zipCode
            let-columns="columns"
            let-rowIndex="rowIndex">
            <tr>
              @for (col of cols; track col) {
                <td>
                  <span class="p-column-title">{{col.header}}</span>
                  @if (col.style == 'percentage') {
                    <span>{{zipCode[col.field]}}@if (zipCode[col.field]) {
                      <span>%</span>
                    } </span>
                  }
                  @if (!col.style) {
                    <span>{{zipCode[col.field]}}</span>
                  }
                </td>
              }
              <td>
                @if (zipCode.code != 00000) {
                  <p-button
                    
                    type="button"
                    icon="pi pi-pencil"
                    (click)="editZipCode(zipCode)"
                    severity="info" >
                  </p-button>
                }
                @if (zipCode.code != 00000) {
                  <p-button
                    
                    type="button"
                    icon="pi pi-trash"
                    (click)="deleteZipCode(zipCode)"
                    severity="danger">
                  </p-button>
                }
              </td>
            </tr>
          </ng-template>
        </p-table>
        <br>
